import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Ganhador0425 from "../../assets/images/ganhador-0425.jpg";
import Ganhador0525 from "../../assets/images/ganhador-0525.jpg";
import Ganhador0625 from "../../assets/images/ganhador-0625.jpg";
import Ganhador0725 from "../../assets/images/ganhador-0725.jpg";
import Ganhador0825 from "../../assets/images/ganhador-0825.jpg";
import Ganhador0925 from "../../assets/images/ganhador-0925.jpg";
import Ganhador1025 from "../../assets/images/ganhador-1025.jpg";
import Ganhador1125 from "../../assets/images/ganhador-1125.jpg";
import Ganhador1225 from "../../assets/images/ganhador-1225.jpg";
import "./AccordionAnt.css";

export default function AccordionAnt(props) {
  const [isOpen, setIsOpen] = useState(false);

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="ganhadores-accordion">
      <button className="accordion-btn" onClick={() => setIsOpen(!isOpen)}>
        {props.title}
      </button>
      {isOpen && (
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          className="ganhadores-accordion-ant"
          touch={true}
          controls={true}
          indicators={true}
        >
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0425}
                  alt="Ganhador de Abril"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Abril</h2>
                </Row>
                <Row>
                  <h3>GISELE RIBEIRO</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Televisor AOC Modelo Smart 43''
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>12/04/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>26442
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0525}
                  alt="Ganhador de Maio"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Maio</h2>
                </Row>
                <Row>
                  <h3>ARIELSON INÁCIO MULLER</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Smartphone Samsung, modelo Galaxy A55
                      128GB
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>10/05/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>067891
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0625}
                  alt="Ganhador de Junho"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Junho</h2>
                </Row>
                <Row>
                  <h3>CLARICE FERRAZ RODRIGUES</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Geladeira da marca consul, modelo
                      Frost Free 340L
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>14/06/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>186157
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0725}
                  alt="Ganhador de Julho"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Julho</h2>
                </Row>
                <Row>
                  <h3>LEO CRISTIANO DICKEL</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Notebook da marca Lenovo, modelo Core
                      i3 4GB
                    </p>
                    <p>
                      <span>Cidade: </span>Ivoti
                    </p>
                    <p>
                      <span>Data do sorteio: </span>24/07/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>095740
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0825}
                  alt="Ganhador de Agosto"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Agosto</h2>
                </Row>
                <Row>
                  <h3>REGINA GONÇALVES</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Geladeira da marca Consul, modelo
                      Frost Free 340L
                    </p>
                    <p>
                      <span>Cidade: </span>Tramandaí
                    </p>
                    <p>
                      <span>Data do sorteio: </span>09/08/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>138395
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador0925}
                  alt="Ganhador de Setembro"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Setembro</h2>
                </Row>
                <Row>
                  <h3>JOÃO CORREA DA SILVA</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Notebook da marca Lenovo, modelo Core
                      i3 4GB
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>13/09/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>32310
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador1025}
                  alt="Ganhador de Outubro"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Outubro</h2>
                </Row>
                <Row>
                  <h3>IARA EMILIA DA SILVA</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Televisor da marca AOC, modelo Smart
                      43''
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>11/10/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>129520
                    </p>
                    <p>
                      <span>Número contemplado: </span>129531
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador1125}
                  alt="Ganhador de Novembro"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Novembro</h2>
                </Row>
                <Row>
                  <h3>CLAIR ALVES CASELANI</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Smartphone Samsung, modelo Galaxy A55
                      128GB
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>08/11/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>022734
                    </p>
                    <p>
                      <span>Número contemplado: </span>022741
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
          <Carousel.Item>
            <Row>
              <Col className="ganhadores-carousel-first-col-ant">
                <img
                  src={Ganhador1225}
                  alt="Ganhador de Dezembro"
                  className="ganhadores-carousel-img-ant"
                />
              </Col>
              <Col className="ganhadores-carousel-second-col-ant">
                <Row>
                  <h2>Dezembro</h2>
                </Row>
                <Row>
                  <h3>MARTA ELENA DA ROSA</h3>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <span>Prêmio: </span>Ar condicionado TCL 12.000 BTUs
                    </p>
                    <p>
                      <span>Cidade: </span>Novo Hamburgo
                    </p>
                    <p>
                      <span>Data do sorteio: </span>13/12/2025
                    </p>
                    <p>
                      <span>Número sorteado: </span>036738
                    </p>
                    <p>
                      <span>Número contemplado: </span>036685
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Carousel.Item>
        </Carousel>
      )}
    </div>
  );
}
